import Vue from "vue";
const vm = new Vue()

export const getListShop = async ( under_by = false ) => {
    return new Promise((resolve, reject) => {
        vm.$http.get( vm.$API_URL + "/shop/list" , {
            headers: {
                Token: localStorage.getItem("access_token")
            },
            params:{
                under_by: under_by
            },
            }).then( res => {
                if (!res.data.status) {   
                    reject(res.data.error);
                }
                resolve(res.data.data)
            })
    })
}

export const exportTransaction = async ( roleName ) => {
    return new Promise((resolve, reject) => {
        vm.$http.get( vm.$API_URL + "/shippop/export/transaction" , {
            headers: {
                Token: localStorage.getItem("access_token"),
            },
            params: {
                role: roleName
            },
            responseType: 'blob'
            }).then( res => {
                resolve(res.data)
            })
    })
}
